<script lang="ts">
import {
  defineComponent,
  onMounted,
  onUnmounted,
  type PropType,
  watch,
} from 'vue'

import {
  type DeeplinkElementType,
  isDeeplinkElementType,
} from '@/pages/menuEntries/MenuEntry.type'
import {
  commitPreview,
  type PreviewPageData,
} from '@/shared/store/preview.store'

/**
 * Invisible component to synchronize the mobile preview from any page.
 * Dropping this component into a template will set the target for the "Resync" button.
 */
export default defineComponent({
  name: 'PreviewSync',
  props: {
    /** The type of page to show in the preview (e.g. 'GUEST', 'SPONSOR_LIST', 'HOME') */
    page: {
      type: String as PropType<DeeplinkElementType>,
      required: true,
      validator: (v: string) => isDeeplinkElementType(v),
    },
    /** Optional data associated with the page (e.g., { guestId: '123' }) */
    pageData: {
      type: Object as PropType<PreviewPageData>,
      required: false,
      default: () => ({}),
    },
  },
  setup(props) {
    const sync = () => {
      commitPreview('setPreview', {
        resyncPage: props.page,
        resyncPageData: props.pageData,
        resyncToHome: false,
      })
    }

    onMounted(sync)

    // Automatically re-sync if the page or data changes dynamically
    watch(() => [props.page, props.pageData], sync, { deep: true })

    onUnmounted(() => {
      commitPreview('resetNavigation')
    })

    // This component renders nothing
    return () => null
  },
})
</script>
